/** Keep in sync with portal `KIOSK_MEMBERSHIP_POS_FLOW_QUERY_PARAM`. */
export const KIOSK_MEMBERSHIP_POS_FLOW_QUERY_PARAM = 'posMembershipFlow'

/** Keep in sync with portal `KIOSK_MEMBERSHIP_ENROLLMENT_FLOW_ID_QUERY_PARAM`. */
export const KIOSK_MEMBERSHIP_ENROLLMENT_FLOW_ID_QUERY_PARAM =
  'membershipFlowId'
